export * from './socialIconLink.css'
